<template>
  <div>
    <div>
      <h2>{{ $t("log.mail.text") }}</h2>
    </div>
    <div class="font-size-11" style="overflow-y: auto;">
      <table class="table table-bordered table-striped">
        <thead class="bg-secondary text-white">
          <tr>
            <th style="width: 1%">
              <b-dropdown split :text="$t('common.all-select')" class="btn-block" variant="secondary" size="sm" @click="selectAllItems">
                <template #button-content>
                  <b> {{ selectedItems.length > 0 ? $t("common.deselect-all") : $t("common.select-all-items") }}</b>
                </template>

                <b-dropdown-item href="#" @click="multipleDeleteById(selectedItems)" :disabled="!isAtLeastOneItemSelected">
                  <i class="bx bx-trash-alt text-danger" v-b-tooltip.hover :title="$t('common.delete')"></i> {{ $t("common.delete") }} ({{ selectedItems.length }})
                </b-dropdown-item>
                <b-dropdown-item href="#" @click="deleteAll()">
                  <i class="bx bx-trash-alt text-dark" v-b-tooltip.hover :title="$t('common.delete')"></i> {{ $t("common.delete-all") }}
                </b-dropdown-item>
              </b-dropdown>
            </th>
            <th style=" width: 9% ; ">{{ $t("log.mail.mail-status") }}</th>
            <sortable-table-head field="recipient" :text="$t('log.mail.recipient')" :request="request" />
            <sortable-table-head field="subject" :text="$t('log.mail.subject')" :request="request" />
            <th style=" width: 11% ; ">{{ $t("log.mail.read-status") }}</th>
            <th style=" width: 11% ; ">{{ $t("log.mail.read-date") }}</th>
            <th>{{ $t("log.mail.error-content") }}</th>
            <sortable-table-head field="createdAt" :text="$t('log.mail.sent-date')" :request="request" />
            <th scope="col" style="width: 12%">
              <a href="javascript:;" @click="toggleFilter">
                <span v-if="filterEnabled" class="text-warning">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-hide") }}
                </span>
                <span v-else class="text-white">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-show") }}
                </span>
              </a>
            </th>
          </tr>
        </thead>

        <tbody>
          <tr v-if="filterEnabled">
            <th></th>
            <th></th>
            <th><input class="form-control" v-model="recipientFilter" /></th>
            <th><input class="form-control" v-model="subjectFilter" /></th>
            <th></th>
            <th></th>
            <th></th>
            <th>
              <date-picker v-model="rangeDate" range :placeholder="$t('common.date')" @change="setTimeValue" :disabled="isAtLeastOneItemSelected" :lang="lang"> </date-picker>
            </th>
            <th></th>
          </tr>
          <template v-if="pagination">
            <tr v-for="item in pagination.docs" :key="item._id">
              <td>
                <div class="text-center">
                  <b-form-checkbox v-model="selectedItems" :value="item" class="custom-checkbox-primary mb-3 " checked></b-form-checkbox>
                </div>
              </td>
              <td>
                <span v-if="item.isSuccess" style="color: green;">
                  {{ $t("common.successful") }}
                </span>
                <span v-else class="text-danger">
                  {{ $t("common.failed") }}
                </span>
              </td>
              <td>
                <div v-for="recipient in item.recipient" :key="recipient">
                  {{ recipient }}
                </div>
              </td>
              <td>
                {{ item.subject | translate }}
              </td>
              <td class="text-center">
                <span class="text-secondary">
                  <i v-if="item.isRead" v-b-tooltip.hover title="Okundu" class="mdi mdi-email-open text-success" style="font-size: 16px;"></i>
                </span>
                <span class="text-dark">
                  <i v-if="!item.isRead" v-b-tooltip.hover title="Okunmadı" class="mdi mdi-email text-muted" style="font-size: 16px;"></i>
                </span>
              </td>
              <td>
                {{ item.readDate | date(true) }}
              </td>
              <td>
                {{ item.errorContent | translate }}
              </td>
              <td>
                {{ item.createdAt | date(true) }}
              </td>
              <td>
                <div class="font-size-16 text-center">
                  <i class="bx bx-trash-alt text-danger hand mr-3" v-b-tooltip.hover :title="$t('common.delete')" @click="deleteById(item)"></i>
                </div>
              </td></tr
          ></template>
        </tbody>
      </table>
    </div>

    <content-loading v-if="loading" />

    <!-- Begin: Pagination -->
    <div v-if="pagination" class="row">
      <div class="col">
        <ul class="pagination pagination-rounded mb-0">
          <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
        </ul>
      </div>
    </div>
    <!-- End: Pagination -->
  </div>
</template>

<script>
const state = "mailLog";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/tr";

export default {
  components: { DatePicker },
  data() {
    return {
      request: {
        options: { page: 1, limit: 15, sort: { createdAt: "desc" } },
        query: {},
      },
      recipientFilter: undefined,
      subjectFilter: undefined,
      filterEnabled: false,
      selectedItems: [],
      rangeDate: [],
      lang: "tr",
    };
  },
  watch: {
    request: {
      deep: true,
      immediate: true,

      handler() {
        this.debounce(() => this.init());
      },
    },

    recipientFilter(n, o) {
      if (!n) {
        delete this.request.query.recipient;
        this.request.query = {
          ...this.request.query,
        };
        return;
      }
      this.request.query = {
        ...this.request.query,
        recipient: { value: n },
      };
    },
    subjectFilter(n, o) {
      if (!n) {
        delete this.request.query.subject;
        this.request.query = {
          ...this.request.query,
        };
        return;
      }
      this.request.query = {
        ...this.request.query,
        subject: { value: n },
      };
    },
    rangeDate(n, o) {
      const startTime = n[0];
      const endTime = n[1];
      if (!n || startTime == null || endTime == null) {
        delete this.request.query.createdAt;
        this.request.query = {
          ...this.request.query,
        };
        return;
      }
      this.request.query = {
        ...this.request.query,
        createdAt: { value: { $gt: startTime, $lt: endTime }, isObject: true },
      };
    },
  },
  computed: {
    pagination() {
      return this.$store.getters[`${state}/pagination`];
    },
    loading() {
      return this.$store.getters[`${state}/isLoading`];
    },
    isAtLeastOneItemSelected() {
      return this.selectedItems.length > 0;
    },
  },
  mounted() {},
  methods: {
    init() {
      this.$store.dispatch(`mailLog/paginate`, this.request);
      this.selectedItems = [];
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/delete`, item._id);
        this.init();

        this.$toast.success(this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;
    },
    selectAllItems() {
      if (this.selectedItems.length > 0) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.pagination.docs.slice();
      }
    },

    async multipleDeleteById(selectedItems) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/multipleDelete`, selectedItems);
        this.init();
        this.$toast.success("'" + this.$options.filters.translate(this.$t("common.delete-successful")));
      } catch (error) {
        console.error(error);
      }
    },
    async deleteAll() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/deleteAll`);
        this.$toast.success("'" + this.$options.filters.translate(this.$t("common.delete-successful")));
        this.init();
      } catch (error) {
        console.error(error);
      }
    },
    setTimeValue(item) {
      this.rangeDate = item;
    },
  },
};
</script>
